/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 8KallFSuh79l

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicLoginFormSecurity.module.css"; // plasmic-import: 8KallFSuh79l/css

createPlasmicElementProxy;

export type PlasmicLoginFormSecurity__VariantMembers = {
  noPadding: "noPadding";
};
export type PlasmicLoginFormSecurity__VariantsArgs = {
  noPadding?: SingleBooleanChoiceArg<"noPadding">;
};
type VariantPropType = keyof PlasmicLoginFormSecurity__VariantsArgs;
export const PlasmicLoginFormSecurity__VariantProps =
  new Array<VariantPropType>("noPadding");

export type PlasmicLoginFormSecurity__ArgsType = {};
type ArgPropType = keyof PlasmicLoginFormSecurity__ArgsType;
export const PlasmicLoginFormSecurity__ArgProps = new Array<ArgPropType>();

export type PlasmicLoginFormSecurity__OverridesType = {
  wrapper?: Flex__<"div">;
  securityDesktop?: Flex__<"div">;
  sslLink?: Flex__<"a"> & Partial<LinkProps>;
  ssl?: Flex__<typeof PlasmicImg__>;
  smLink?: Flex__<"a"> & Partial<LinkProps>;
  sm?: Flex__<typeof PlasmicImg__>;
  trusteLink?: Flex__<"a"> & Partial<LinkProps>;
  truste?: Flex__<typeof PlasmicImg__>;
  socLink?: Flex__<"a"> & Partial<LinkProps>;
  soc?: Flex__<typeof PlasmicImg__>;
  securityXs?: Flex__<"div">;
  top?: Flex__<"div">;
  sslLink2?: Flex__<"a"> & Partial<LinkProps>;
  ssl2?: Flex__<typeof PlasmicImg__>;
  trusteLink2?: Flex__<"a"> & Partial<LinkProps>;
  truste2?: Flex__<typeof PlasmicImg__>;
  bottom?: Flex__<"div">;
  smLink2?: Flex__<"a"> & Partial<LinkProps>;
  sm2?: Flex__<typeof PlasmicImg__>;
  socLink2?: Flex__<"a"> & Partial<LinkProps>;
  soc2?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultLoginFormSecurityProps {
  noPadding?: SingleBooleanChoiceArg<"noPadding">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLoginFormSecurity__RenderFunc(props: {
  variants: PlasmicLoginFormSecurity__VariantsArgs;
  args: PlasmicLoginFormSecurity__ArgsType;
  overrides: PlasmicLoginFormSecurity__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "noPadding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.noPadding
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"wrapper"}
      data-plasmic-override={overrides.wrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.wrapper,
        { [sty.wrappernoPadding]: hasVariant($state, "noPadding", "noPadding") }
      )}
    >
      {(hasVariant(globalVariants, "mobile", "mobileXSmall") ? false : true) ? (
        <div
          data-plasmic-name={"securityDesktop"}
          data-plasmic-override={overrides.securityDesktop}
          className={classNames(projectcss.all, sty.securityDesktop, {
            [sty.securityDesktopnoPadding]: hasVariant(
              $state,
              "noPadding",
              "noPadding"
            )
          })}
        >
          <PlasmicLink__
            data-plasmic-name={"sslLink"}
            data-plasmic-override={overrides.sslLink}
            aria-label={"Open SSL report"}
            className={classNames(projectcss.all, projectcss.a, sty.sslLink)}
            component={Link}
            href={
              "https://secure.ssl.com/site_seals/afc62e84-546bd429/site_report"
            }
            platform={"nextjs"}
            target={"_blank"}
            title={"Open SSL report"}
          >
            <PlasmicImg__
              data-plasmic-name={"ssl"}
              data-plasmic-override={overrides.ssl}
              alt={"SSL logo"}
              className={classNames(sty.ssl)}
              displayHeight={"100%"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={
                hasVariant(globalVariants, "mobile", "mobileXSmall")
                  ? "70px"
                  : "100%"
              }
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/2d5de59cbdbc131416fa5f8a225e5195.svg",
                fullWidth: 88,
                fullHeight: 40,
                aspectRatio: 2.2
              }}
            />
          </PlasmicLink__>
          <PlasmicLink__
            data-plasmic-name={"smLink"}
            data-plasmic-override={overrides.smLink}
            aria-label={"Open Security Metrics certificate"}
            className={classNames(projectcss.all, projectcss.a, sty.smLink)}
            component={Link}
            href={
              "https://www.securitymetrics.com/site_certificate?id=1620588&tk=cc623455be6f550b5bad316af1ed043c"
            }
            platform={"nextjs"}
            target={"_blank"}
            title={"Open Security Metrics certificate"}
          >
            <PlasmicImg__
              data-plasmic-name={"sm"}
              data-plasmic-override={overrides.sm}
              alt={"Security Metrics logo"}
              className={classNames(sty.sm)}
              displayHeight={"100%"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/a34f7265d905c2536c366e7049ea697a.svg",
                fullWidth: 265,
                fullHeight: 150,
                aspectRatio: 1.767857
              }}
            />
          </PlasmicLink__>
          <PlasmicLink__
            data-plasmic-name={"trusteLink"}
            data-plasmic-override={overrides.trusteLink}
            aria-label={"Open TRUSTe certificate"}
            className={classNames(projectcss.all, projectcss.a, sty.trusteLink)}
            component={Link}
            href={
              "https://privacy.trustarc.com/privacy-seal/validation?rid=f8bd7343-167e-42af-b87d-f103b7db3712"
            }
            platform={"nextjs"}
            target={"_blank"}
            title={"Open TRUSTe certificate"}
          >
            <PlasmicImg__
              data-plasmic-name={"truste"}
              data-plasmic-override={overrides.truste}
              alt={"TRUSTe logo"}
              className={classNames(sty.truste)}
              displayHeight={
                hasVariant(globalVariants, "mobile", "mobileXSmall")
                  ? "100%"
                  : "100%"
              }
              displayMaxHeight={
                hasVariant(globalVariants, "mobile", "mobileXSmall")
                  ? "none"
                  : "none"
              }
              displayMaxWidth={
                hasVariant(globalVariants, "mobile", "mobileXSmall")
                  ? "auto"
                  : "100%"
              }
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loader={"plasmic"}
              loading={"lazy"}
              src={
                "https://hostedseal.trustarc.com/privacy-seal/seal?rid=f8bd7343-167e-42af-b87d-f103b7db3712"
              }
            />
          </PlasmicLink__>
          <PlasmicLink__
            data-plasmic-name={"socLink"}
            data-plasmic-override={overrides.socLink}
            aria-label={"Open SOC 2 details"}
            className={classNames(projectcss.all, projectcss.a, sty.socLink)}
            component={Link}
            href={
              "https://www.aicpa-cima.com/topic/audit-assurance/audit-and-assurance-greater-than-soc-2"
            }
            platform={"nextjs"}
            target={"_blank"}
            title={"Open SOC 2 details"}
          >
            <PlasmicImg__
              data-plasmic-name={"soc"}
              data-plasmic-override={overrides.soc}
              alt={"SOC 2 logo"}
              className={classNames(sty.soc)}
              displayHeight={"36px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"84px"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/eb1c7bf06ca966644a4545bce3f37ddc.svg",
                fullWidth: 96,
                fullHeight: 40,
                aspectRatio: 2.4
              }}
            />
          </PlasmicLink__>
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobileXSmall") ? true : false) ? (
        <div
          data-plasmic-name={"securityXs"}
          data-plasmic-override={overrides.securityXs}
          className={classNames(projectcss.all, sty.securityXs)}
        >
          <div
            data-plasmic-name={"top"}
            data-plasmic-override={overrides.top}
            className={classNames(projectcss.all, sty.top)}
          >
            <PlasmicLink__
              data-plasmic-name={"sslLink2"}
              data-plasmic-override={overrides.sslLink2}
              aria-label={"Open SSL report"}
              className={classNames(projectcss.all, projectcss.a, sty.sslLink2)}
              component={Link}
              href={
                "https://secure.ssl.com/site_seals/afc62e84-546bd429/site_report"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open SSL report"}
            >
              <PlasmicImg__
                data-plasmic-name={"ssl2"}
                data-plasmic-override={overrides.ssl2}
                alt={"SSL logo"}
                className={classNames(sty.ssl2)}
                displayHeight={"100%"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"100%"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/2d5de59cbdbc131416fa5f8a225e5195.svg",
                  fullWidth: 88,
                  fullHeight: 40,
                  aspectRatio: 2.2
                }}
              />
            </PlasmicLink__>
            <PlasmicLink__
              data-plasmic-name={"trusteLink2"}
              data-plasmic-override={overrides.trusteLink2}
              aria-label={"Open TRUSTe certificate"}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.trusteLink2
              )}
              component={Link}
              href={
                "https://privacy.trustarc.com/privacy-seal/validation?rid=f8bd7343-167e-42af-b87d-f103b7db3712"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open TRUSTe certificate"}
            >
              <PlasmicImg__
                data-plasmic-name={"truste2"}
                data-plasmic-override={overrides.truste2}
                alt={"TRUSTe logo"}
                className={classNames(sty.truste2)}
                displayHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "100%"
                    : "100%"
                }
                displayMaxHeight={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "none"
                    : "none"
                }
                displayMaxWidth={
                  hasVariant(globalVariants, "mobile", "mobileXSmall")
                    ? "auto"
                    : "100%"
                }
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"100%"}
                loader={"plasmic"}
                loading={"lazy"}
                src={
                  "https://hostedseal.trustarc.com/privacy-seal/seal?rid=f8bd7343-167e-42af-b87d-f103b7db3712"
                }
              />
            </PlasmicLink__>
          </div>
          <div
            data-plasmic-name={"bottom"}
            data-plasmic-override={overrides.bottom}
            className={classNames(projectcss.all, sty.bottom)}
          >
            <PlasmicLink__
              data-plasmic-name={"smLink2"}
              data-plasmic-override={overrides.smLink2}
              aria-label={"Open Security Metrics certificate"}
              className={classNames(projectcss.all, projectcss.a, sty.smLink2)}
              component={Link}
              href={
                "https://www.securitymetrics.com/site_certificate?id=1620588&tk=cc623455be6f550b5bad316af1ed043c"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open Security Metrics certificate"}
            >
              <PlasmicImg__
                data-plasmic-name={"sm2"}
                data-plasmic-override={overrides.sm2}
                alt={"Security Metrics logo"}
                className={classNames(sty.sm2)}
                displayHeight={"100%"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"100%"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/a34f7265d905c2536c366e7049ea697a.svg",
                  fullWidth: 265,
                  fullHeight: 150,
                  aspectRatio: 1.767857
                }}
              />
            </PlasmicLink__>
            <PlasmicLink__
              data-plasmic-name={"socLink2"}
              data-plasmic-override={overrides.socLink2}
              aria-label={"Open SOC 2 details"}
              className={classNames(projectcss.all, projectcss.a, sty.socLink2)}
              component={Link}
              href={
                "https://www.aicpa-cima.com/topic/audit-assurance/audit-and-assurance-greater-than-soc-2"
              }
              platform={"nextjs"}
              target={"_blank"}
              title={"Open SOC 2 details"}
            >
              <PlasmicImg__
                data-plasmic-name={"soc2"}
                data-plasmic-override={overrides.soc2}
                alt={"SOC 2 logo"}
                className={classNames(sty.soc2)}
                displayHeight={"55px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"133px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/0ddc908077ed7b1ea721666e7fe586d8.svg",
                  fullWidth: 145,
                  fullHeight: 60,
                  aspectRatio: 2.416667
                }}
              />
            </PlasmicLink__>
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  wrapper: [
    "wrapper",
    "securityDesktop",
    "sslLink",
    "ssl",
    "smLink",
    "sm",
    "trusteLink",
    "truste",
    "socLink",
    "soc",
    "securityXs",
    "top",
    "sslLink2",
    "ssl2",
    "trusteLink2",
    "truste2",
    "bottom",
    "smLink2",
    "sm2",
    "socLink2",
    "soc2"
  ],
  securityDesktop: [
    "securityDesktop",
    "sslLink",
    "ssl",
    "smLink",
    "sm",
    "trusteLink",
    "truste",
    "socLink",
    "soc"
  ],
  sslLink: ["sslLink", "ssl"],
  ssl: ["ssl"],
  smLink: ["smLink", "sm"],
  sm: ["sm"],
  trusteLink: ["trusteLink", "truste"],
  truste: ["truste"],
  socLink: ["socLink", "soc"],
  soc: ["soc"],
  securityXs: [
    "securityXs",
    "top",
    "sslLink2",
    "ssl2",
    "trusteLink2",
    "truste2",
    "bottom",
    "smLink2",
    "sm2",
    "socLink2",
    "soc2"
  ],
  top: ["top", "sslLink2", "ssl2", "trusteLink2", "truste2"],
  sslLink2: ["sslLink2", "ssl2"],
  ssl2: ["ssl2"],
  trusteLink2: ["trusteLink2", "truste2"],
  truste2: ["truste2"],
  bottom: ["bottom", "smLink2", "sm2", "socLink2", "soc2"],
  smLink2: ["smLink2", "sm2"],
  sm2: ["sm2"],
  socLink2: ["socLink2", "soc2"],
  soc2: ["soc2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  wrapper: "div";
  securityDesktop: "div";
  sslLink: "a";
  ssl: typeof PlasmicImg__;
  smLink: "a";
  sm: typeof PlasmicImg__;
  trusteLink: "a";
  truste: typeof PlasmicImg__;
  socLink: "a";
  soc: typeof PlasmicImg__;
  securityXs: "div";
  top: "div";
  sslLink2: "a";
  ssl2: typeof PlasmicImg__;
  trusteLink2: "a";
  truste2: typeof PlasmicImg__;
  bottom: "div";
  smLink2: "a";
  sm2: typeof PlasmicImg__;
  socLink2: "a";
  soc2: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLoginFormSecurity__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLoginFormSecurity__VariantsArgs;
    args?: PlasmicLoginFormSecurity__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLoginFormSecurity__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLoginFormSecurity__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLoginFormSecurity__ArgProps,
          internalVariantPropNames: PlasmicLoginFormSecurity__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoginFormSecurity__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrapper") {
    func.displayName = "PlasmicLoginFormSecurity";
  } else {
    func.displayName = `PlasmicLoginFormSecurity.${nodeName}`;
  }
  return func;
}

export const PlasmicLoginFormSecurity = Object.assign(
  // Top-level PlasmicLoginFormSecurity renders the root element
  makeNodeComponent("wrapper"),
  {
    // Helper components rendering sub-elements
    securityDesktop: makeNodeComponent("securityDesktop"),
    sslLink: makeNodeComponent("sslLink"),
    ssl: makeNodeComponent("ssl"),
    smLink: makeNodeComponent("smLink"),
    sm: makeNodeComponent("sm"),
    trusteLink: makeNodeComponent("trusteLink"),
    truste: makeNodeComponent("truste"),
    socLink: makeNodeComponent("socLink"),
    soc: makeNodeComponent("soc"),
    securityXs: makeNodeComponent("securityXs"),
    top: makeNodeComponent("top"),
    sslLink2: makeNodeComponent("sslLink2"),
    ssl2: makeNodeComponent("ssl2"),
    trusteLink2: makeNodeComponent("trusteLink2"),
    truste2: makeNodeComponent("truste2"),
    bottom: makeNodeComponent("bottom"),
    smLink2: makeNodeComponent("smLink2"),
    sm2: makeNodeComponent("sm2"),
    socLink2: makeNodeComponent("socLink2"),
    soc2: makeNodeComponent("soc2"),

    // Metadata about props expected for PlasmicLoginFormSecurity
    internalVariantProps: PlasmicLoginFormSecurity__VariantProps,
    internalArgProps: PlasmicLoginFormSecurity__ArgProps
  }
);

export default PlasmicLoginFormSecurity;
/* prettier-ignore-end */
